import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { connect } from 'react-redux';

import * as actions from '../../../globals/methods/actions';
import * as globalSelectors from '../../../globals/methods/selectors';

const DEFAULT_ERROR_MESSAGE = `Oops... something went wrong`;
const DEFAULT_SUCCESS_MESSAGE = `Success!`;

export class MessageNotifier extends Component {

    render() {
        const {hasError, hasSuccess, message, clearMessage} = this.props;

        if (hasError) {
            Alert.error(message || DEFAULT_ERROR_MESSAGE);
            clearMessage ? clearMessage() : null;
        }
        if (hasSuccess) {
            Alert.success(message || DEFAULT_SUCCESS_MESSAGE);
            clearMessage ? clearMessage() : null;
        }
        return (
                <Alert stack={true} 
                       timeout={6000} 
                       position="top-right"
                       effect="stackslide"
                       offset={50}/>
                );
    }

}

MessageNotifier.propTypes = {
    hasError: PropTypes.bool,
    message: PropTypes.string,
    clearMessage: PropTypes.func
};

const mapStateToProps = state => {
    return {
        hasError: globalSelectors.getHasError(state),
        hasSuccess: globalSelectors.getHasSuccess(state),
        message: globalSelectors.getMessage(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearMessage: () => dispatch(actions.clearMessage())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageNotifier);